/*
 * @author: yanhoup
 * @description: OBKoro1
 */
/**
 * @author: yanhoup
 * @description: tab组件(基于fusionTab上扩展，兼容Tab组件的api)
 */

import React from 'react';
import { Tab } from '@fpxfd/next';
import { FpxTabProps } from './index.interface';
import styles from './index.module.scss';

const FpxTab = ({ dataSource, className, shape, onChange = () => {}, ...lastProps }: FpxTabProps) => {
  return (
    <Tab
      {...lastProps}
      onChange={(value) => onChange(value === '0' ? '' : value)}
      className={`${styles.FpxTab} ${className} tab_${shape}`}
    >
      {dataSource.map((e) => (
        <Tab.Item key={e.value} title={e.label} />
      ))}
    </Tab>
  );
};

export default FpxTab;
